import React , {Component, useEffect, useState, useRef, createRef } from "react";
import { useTheme } from "@mui/material/styles";
import GridItem from "../../components/Grid/GridItem.jsx";
import { useNavigate, useParams, Link } from "react-router-dom";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Button from "../../components/CustomButtons/Button.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import {MenuItem, Menu, Box, Typography, Breadcrumbs, Tooltip, Fab, CardContent, Accordion, AccordionSummary, AccordionDetails, } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { baseUrl } from '../../components/shared/baseUrl.js';
import axios from 'axios';
import {useSelector, useDispatch} from 'react-redux';
import {motion, AnimatePresence} from 'framer-motion';
import Skeleton from "@mui/material/Skeleton"
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';




export const styles = (theme) =>({
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    cardTitleWhite: {
      color: "##b34bbe",
      marginTop: "0px",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none"
    },
    fontCursive: {
      fontFamily:"'Lucida Handwriting', 'Cursive'"
    },
    fontGaramond: {
      fontFamily:"'Garamond', 'Serif'"
    },
    fontCourier:{
      fontFamily:"'Lucida Console','Courier New', 'monospace'"
    },
    fontPapyrus:{
      fontFamily:"'Papyrus','Fantasy'"
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
        fontFamily:"'Lucida Handwriting', 'Brush Script MT'"
      },
      secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
        fontFamily:"'Lucida Handwriting', 'Brush Script MT'"
      },
      backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        background: "rgba(0,0,0,0.5)",
        zIndex: 10
      },
      modal:{
          position: 'relative',
          maxWidth: '1000px',
          margin : '0 auto',
          padding: '40 px 20 px',
          background: "rgba(0,0,0,0.5)",
          backgroundColor: 'white',
          borderRadius:'10 px',
          textAlign:'center',
          zIndex: 10

      }
  });

  const backdrop = {
    visible:{opacity: 1},
    hidden:{opacity: 0}
}

const modal = {
    hidden:{
      y:"-100vh",
      opacity: 1
    },
    visible:{
      y: "200px",
      opacity:1,
      transition:{ delay: 0.5 }
    },
    exit:{
      y:"500vh",
      opacity: 1,
      transition:{ delay: 1 }

    },
  }
  const secModal = {
    hidden:{
      x:"300vh",
      opacity: 1
    },
    visible:{
      x: "100px",
      y: "200px",
      opacity:1,
      transition:{ delay: 0.5 }
    },
    exit:{
      x:"400vh",
      opacity: 1,
      transition:{ delay: 1 }

    },
  }

  var cla = {
    "_id":"6006f33eef2c0d65ccbf6601",
    "title": "Class IX",
    "teacherId":"5fe192d970d8c633c005da24",
    "sessionActive":false,
    "image":"assets/images/cimage.jpg",
    "std":"IX"
  }



  export default function Scenario(props) {

    var interval = null
    const [clas, setclas] = React.useState([]);
    const [loading, setloading] = React.useState(true);
    const [loadintro, setloadintro] = React.useState(true);
    const theme = useTheme()
    const classes = styles(theme);
    const user = useSelector(state => state.user)
    const [expanded, setExpanded] = React.useState(false);
    const [myModal, setmyModal] = React.useState(true);
    const [secondModal, setsecondModal] = React.useState(false);
    const [thirdModal, setthirdModal] = React.useState(false);
    const [mydata, setmydata] = React.useState([]);
    const { classId, sesId, profileId } = useParams();


    useEffect(() => {

        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const classid = classId;
        //console.log(classId)
        //const profileId = profileId;


        const loadData=()=>{
          const config = {
            headers: { Authorization: `Bearer ${user.token}` }
        };

        try{
         
          setclas(cla)
          axios.get(`${baseUrl}pyinterpreter/profile/${profileId}`,config, { cancelToken: source.token })
          .then((response) =>{
            console.log(response.data)
            setmydata(response.data)
            setloading(false)

          })
          .catch((error)=>{
          console.log(error);
          });
        } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }

    };

    loadData();

    return() => {source.cancel();
    };


    }, []);

    useEffect(() => {  
      clearInterval(interval);
  
     })
  
    console.log(mydata)
     const history = useNavigate();

    const handleStartActivity = () => {
      console.log(mydata)
     if(mydata.activity1[0].decomposition[0].completed==true){                       
      history(`/student/dashboard/viewstudentclass/${clas._id}/session/${profileId}/activity1${mydata.activity1[0].level}`)
     }
     else{
     
      var problemtype = 'medium'
    //mydata.activity1[0].profileScore=50
      if(parseInt(mydata.activity1[0].profileScore)<40){
        problemtype='easy'
      }
      else if(parseInt(mydata.activity1[0].profileScore)>75){
        problemtype='hard'
      }
      //problemtype='hard'
      mydata.activity1[0].level=problemtype
      mydata.activity1[0].decomposition[0].created=Date.now
      const mdata=
      {
        act: 'activity1',
        data: mydata.activity1[0]
      }                     
      console.log(mdata)

      axios.put(`${baseUrl}pyinterpreter/profile/${profileId}`, mdata)
      .then((response) => {
          console.log(response.data)
          const activity = response.data

          setmydata(activity)
          history(`/student/dashboard/viewstudentclass/${clas._id}/session/${profileId}/activity1${response.data.activity1[0].level}`)
      })
    }
  }

const gotoActivity = (num) =>{
  if(num<7){
    var newact = 'activity'+num
    var leve = mydata[newact][0].level
    history(`/student/dashboard/viewstudentclass/${clas._id}/session/${profileId}/activity${num}${leve}`)
  }
  else{
    history(`/student/dashboard/viewstudentclass/${clas._id}/session/${profileId}/activityposttest`)
  }
  
}
    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setloadintro(false)
        setExpanded(isExpanded ? panel : false);
      };
        
    const closeSecondModal=()=>{
      setsecondModal(!secondModal)
      setthirdModal(!thirdModal)
    }
    const closeModal=()=>{
      setmyModal(!myModal)
      setsecondModal(!secondModal)

    }
    const backSecondModal=()=>{
      setthirdModal(!thirdModal)
      setsecondModal(!secondModal)

    }

    const backFirstModal=()=>{
      setmyModal(!myModal)
      setsecondModal(!secondModal)

    }
    const closeThirdModal=()=>{
      setthirdModal(!thirdModal)
    }
    
      return(
      loading!==true?
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                <Link color="inherit" to="/student/dashboard">
                    Dashboard
                </Link>
                <Link color="inherit" to={`/student/dashboard/viewsession/${clas._id}`}>
                    <Typography color="textPrimary"> {clas.title}</Typography>
                </Link>
                <Typography color="textPrimary"> Scenario </Typography>
                </Breadcrumbs>
            </GridItem>
            <GridItem xs={12} sm={12} md={12} >
              <Typography variant="h5" sx={classes.cardTitleWhite} align="center"> Water Pollution </Typography>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>

      {myModal && (
            <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal}
                    variants={modal} 
                    >
                    <Button color="success" variant="contained" onClick={closeModal} 
                      title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                        Next
                    </Button>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={4}>
                        <img alt='Thinking Panda' width="80" height="200" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={8}>
                        <p style={classes.fontCursive}>Hello!! I am your friend "Thinking panda" </p>
                        <p style={classes.fontCursive}> Welcome to the <span style={{ color: 'royalblue'}}> Water pollution </span> scenario </p>
                        <p style={classes.fontCursive}>I will help you in your quest to explore the story and solve multiple problems during the exploration</p>
                        <p style={classes.fontCursive}>Let's embark on our journey. Click Next button for more details regarding the scenario</p>
                      </GridItem>
                    </GridContainer> 
                  </motion.div>
                </motion.div>
            </AnimatePresence>)}
            {secondModal && (
            <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal}
                    variants={modal} 
                    >
                    <Button color="success" variant="contained" onClick={backFirstModal} 
                      title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                        Back
                    </Button>
                    <Button color="success" variant="contained" onClick={closeSecondModal} 
                      title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                        Next
                    </Button>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={3}>
                        {/* <Typography variant="p"> Thinking Panda says...</Typography> */}
                        <img alt='Thinking Panda' width="80" height="200" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <p style={classes.fontCursive}>Due to a cyclone last night, a ship carrying crude oil collided with a small island near Andaman and Nicobar.</p> 
                        <p style={classes.fontCursive}>The impact of crash was so high that the ship has developed multiple cracks (holes) in it.</p> 
                        <p style={classes.fontCursive}>Crude oil is spilling into the ocean from these holes, putting marine life in grave danger. </p>
                        <p style={classes.fontCursive}>Indian Government is planning a rescue mission after receiving a SOS message for help</p>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <img style={{ height: '250px' }} alt='Damaged Ship' className="card-img-top" src={baseUrl+'assets/images/ship_water.jpg'} />
                      </GridItem>
                    </GridContainer>
                    
                  </motion.div>
                </motion.div>
            </AnimatePresence>)}
            {thirdModal && (
            <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal}
                    variants={secModal} 
                    >
                    <Button color="success" variant="contained" onClick={backSecondModal} 
                      title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                        Back
                    </Button>
                    <Button color="success" variant="contained" onClick={closeThirdModal} 
                      title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                        Ok
                    </Button>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={2}>
                        {/* <Typography variant="p"> Thinking Panda says...</Typography> */}
                        <img alt='Thinking Panda' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={7}> 
                        <p style={classes.fontCursive}> Indian coast guard team is given the task to rescue the ship.You are part 
                        of a rescue team of Indian coast guard for a mission to stop oil spilling in the ocean. Your team needs to fix the broken ship and bring back it safely to the coast.</p>
                        <p style={classes.fontCursive}>Your team will travel from the coast of Chennai to the spilling area near andaman islands.</p>
                        <p style={classes.fontCursive}>First, your team will be travelling on a boat to a nearby island and then you need to travel on foot to reach the spilling area since the water level is low there.</p>
                        <p style={classes.fontCursive}>During the trip your team will have to solve multiple problems in order to proceed forward in the mission and ensure the safety of marine life.</p>
                        <h5 style={classes.fontCursive} >Click <span style={{ color: 'royalblue'}}> OK </span> and then click <span style={{ color: 'royalblue'}}>'START ACTIVITY'</span> to start the Mission </h5>  
                      </GridItem>
                      <GridItem xs={12} sm={12} md={3}>
                        <img style={{ height: '300px' }} alt='Damaged Ship' className="card-img-top" src={baseUrl+'assets/images/coast_guard.png'} />
                      </GridItem>
                    </GridContainer>
 
                  </motion.div>
                </motion.div>
            </AnimatePresence>)}
           
            <Accordion expanded={loadintro==true? true : expanded === 'panel1'} onChange={handleAccordionChange('panel1')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1bh-content"
                  id="panel1bh-header"
                >
                  <Typography sx={classes.heading}>.</Typography>
                  <Typography sx={classes.secondaryHeading}><b>Introduction</b></Typography>
                </AccordionSummary>
                <AccordionDetails> 
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>      
                          <Card style={{border: "1px solid blue"}}>
                              <CardHeader className="bg-primary text-white">Introduction</CardHeader>
                              <CardContent>
                              <blockquote className="blockquote">
                                  <p> A ship carrying crude oil has crashed into a small island near Andaman and Nicobar due to a cyclone last night. </p>    
                                  <p> The impact of crash was so high that the ship has developed multiple cracks (holes) in it. </p>
                                  <p> From these holes crude oil is spilling into the ocean causing the life of marine life in huge danger.</p> 
                              </blockquote>    
                              </CardContent>
                          </Card>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                      <Card>
                          <img alt='Damaged Ship' className="card-img-top" width="200" height="300" src={baseUrl+'assets/images/ship_water.jpg'} />
                      </Card>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}> 
                              
                              <Card style={{border: "1px solid blue"}}>

                                  <CardHeader className="bg-primary text-white">The impact of oil spilling into the ocean may cause following damages:</CardHeader>
                                  <CardContent>
                                  <blockquote className="blockquote">
                                      <dl className="row p-1">
                                          <dt className="col-1">1.</dt>
                                          <dd className="col-11">Oil destroys the insulating ability of fur-bearing mammals, such as sea otters, and the water repellency of a bird's feathers, thus exposing these creatures to the harsh elements. Without the ability to repel water and insulate from the cold water, birds and mammals will die from hypothermia.</dd>
                                          <dt className="col-1">2.</dt>
                                          <dd className="col-11">Juvenile sea turtles can also become trapped in oil and mistake it for food. Dolphins and whales can inhale oil, which can affect lungs, immune function and reproduction. Many birds and animals also ingest oil when they try to clean themselves, which can poison them</dd>
                                          <dt className="col-1">3.</dt>
                                          <dd className="col-11">Fish, shellfish, and corals may not be exposed immediately, but can come into contact with oil if it is mixed into the water column shellfish can also be exposed in the intertidal zone. When exposed to oil, adult fish may experience reduced growth, enlarged livers, and changes in heart and respiration rates, fin erosion, and reproduction impairment. Fish eggs and larvae can be especially sensitive to lethal and sub lethal impacts. Even when lethal impacts are not observed, oil can make fish and shellfish unsafe for humans to eat.</dd>
                                          
                                      </dl>
                                      <p>
                                        For the above reason, it is clearly visible that marine ecosystem is in huge danger and therefore we need to stop the oil from spilling. 
                                      </p>
                                  </blockquote>    
                                  </CardContent>
                              </Card>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                          <Card>
                            <img alt='Marine Otter' className="card-img-top" src={baseUrl+'assets/images/marineOtter.jpg'} />
                            <img alt='Marine Life' className="card-img-top" src={baseUrl+'assets/images/marine_life.jpg'} />
                          </Card>
                    </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                          <Card style={{border: "1px solid blue"}}>
                                  <CardHeader className="bg-primary text-white">The Mission</CardHeader>
                              <CardContent>
                              <blockquote className="blockquote">
                                  <p>You are part of a rescue team of Indian coast guard for a mission to stop oil spilling in the ocean.</p>
                                  <dl className="row p-1">
                                      <dd className="col-12"> You need to fix the broken ship and bring back it safely to the coast. </dd>
                                      <dd className="col-12"> Your team will travel from the coast of Chennai to the spilling area near andaman islands. </dd>
                                      <dd className="col-12"> You will be travelling on a boat to a nearby island and then you need to travel on foot to reach the spilling area since the water level is low there. </dd>
                                      <dd className="col-12"> You will have to solve multiple problems in order to proceed forward in the mission and ensure the safety of marine life. </dd>
                                      <dd className="col-12"> For each problem you need to work as a group and develop an algorithm to find a solution and consequently write a computer program which would give the correct answer. </dd>
                                      Each correct answer will ensure that you are one step closer to complete the mission.  
                                  </dl> 
                                  </blockquote>
                              </CardContent>
                          </Card>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <Card>
                      <img alt='Coast Guard' className="card-img-top" src={baseUrl+'assets/images/coast_guard.png'} />
                    </Card>
                  </GridItem>
                </GridContainer>
            </AccordionDetails>
            </Accordion> 
            </GridItem>
           
            <GridItem xs={12} sm={12} md={9}>
              <h1>Let's Start the Mission</h1>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
                    
                    {mydata.activity1[0].completed==true && mydata.activity2[0].problemStatement!=''?<>
                      <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState) => (
                          <React.Fragment>
                              <Button color="primary" sx={{ fontSize: '50px' }} size="lg" variant="contained" {...bindTrigger(popupState)}>
                                Start Activity
                              </Button>
                              <DoubleArrowIcon fontSize="large" />
                              <Menu {...bindMenu(popupState)}>
                                <MenuItem onClick={()=>gotoActivity(1)}>{mydata.activity1[0].completed==true && mydata.activity2[0].problemStatement!=''?'Activity1(Completed)':'Activity1'}</MenuItem>
                                {mydata.activity1[0].completed==true && mydata.activity2[0].problemStatement!=''?<MenuItem onClick={()=>gotoActivity(2)}>{mydata.activity2[0].completed==true && mydata.activity3[0].problemStatement!=''?'Activity2(Completed)':'Activity2'}</MenuItem>:null}
                                {mydata.activity2[0].completed==true && mydata.activity3[0].problemStatement!=''?<MenuItem onClick={()=>gotoActivity(3)}>{mydata.activity3[0].completed==true && mydata.activity4[0].problemStatement!=''?'Activity3(Completed)':'Activity3'}</MenuItem>:null}
                                {mydata.activity3[0].completed==true && mydata.activity4[0].problemStatement!=''?<MenuItem onClick={()=>gotoActivity(4)}>{mydata.activity4[0].completed==true && mydata.activity5[0].problemStatement!=''?'Activity4(Completed)':'Activity4'}</MenuItem>:null}
                                {mydata.activity4[0].completed==true && mydata.activity5[0].problemStatement!=''?<MenuItem onClick={()=>gotoActivity(5)}>{mydata.activity5[0].completed==true && mydata.activity6[0].problemStatement!=''?'Activity5(Completed)':'Activity5'}</MenuItem>:null}
                                {mydata.activity5[0].completed==true?<MenuItem onClick={()=>gotoActivity(6)}>{mydata.activity6[0].completed==true && mydata.postTest[0].bebras!=''?'Activity6(Completed)':'Activity6'}</MenuItem>:null}
                                {mydata.activity6[0].completed==true?<MenuItem onClick={()=>gotoActivity(7)}>{mydata.postTest[0].bebras!=''?'Post Test':null}</MenuItem>:null}
                              </Menu>
                          </React.Fragment>
                          )}
                        </PopupState>
                    </>
                    :<>
                    <Button color="primary" variant="contained" onClick={handleStartActivity}  
                    title="Click to start Activity" sx={{ fontSize: '50px' }} size="lg" >
                        Start Activity
                        
                    </Button>
                    <DoubleArrowIcon fontSize="large" /></>
                    }
                    
            </GridItem>

        </GridContainer>:<GridContainer spacing={2}>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5, padding: 2 }}>
            <Skeleton animation="wave" variant="rectangular" width={640} height={400} />    
          </Box>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5 }}>
            <Skeleton animation="wave" variant="rectangular" width={640} height={400} />    
          </Box> 
          </GridItem>
        <GridItem xs={12} sm={12} md={12}>         
          <Skeleton variant="text" />
        </GridItem>
      </GridContainer>
        );
    }